import { useSelector } from 'react-redux';
import { routeThreadId } from '@/redux/selectors/pieveSelectors/routeSelectors.js';
import AssistantThreadsHandler from './handlers/AssistantThreadsHandler.jsx';
import ThreadOpenedHandler from './handlers/ThreadOpenedHandler.jsx';
import HomePage from './pages/HomePage.jsx';
import ThreadPage from './pages/ThreadPage.jsx';
import './styles/assistant.css';

/** Assistant: the home with a new request and every conversation (`/`), and one conversation (`/threads/:threadId`). */
const AssistantScreen = () => {
  const threadId = useSelector(routeThreadId);

  return (
    <>
      <AssistantThreadsHandler />
      <ThreadOpenedHandler />
      {threadId ? <ThreadPage /> : <HomePage />}
    </>
  );
};

export default AssistantScreen;
